import React from 'react';
import { useState, useEffect, useContext } from 'react';
import { Dialog, DialogContent, DialogTitle, Button, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import axios from '../../../common/AxiosConfig';
import { AppContext } from '../../../../RoutesWithAuth';
import { getFormatedDate } from '../../../common/commons';
import GetAppIcon from '@mui/icons-material/GetApp';
import CloseIcon from '@mui/icons-material/Close';
import { CheckBoxOutlineBlank } from '@mui/icons-material';
import { standardButtonStyle } from './buttonStyles';
import { LoadingIndicator } from '../reports/reconcilationreport/MuiStyled';

const useStyles = makeStyles(() => ({
    dialogPaper: {
        width: '90%',
        maxWidth: '1200px',
        height: '80vh',
        maxHeight: '80vh',
    },
    dialogTitle: {
        background: 'linear-gradient(135deg, #1e3a5f 0%, #267db7 125%, #3b9edd 100%)',
        color: '#fff',
        padding: '8px 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    titleText: {
        fontSize: '1.1rem',
        fontWeight: 600,
        letterSpacing: '0.3px',
    },
    iconActions: {
        display: 'flex',
        gap: '8px',
        '& button': {
            color: '#fff',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '6px',
            display: 'flex',
            alignItems: 'center',
            borderRadius: '50%',
            '&:hover': {
                background: 'rgba(255,255,255,0.1)',
            },
        },
    },
    dialogContent: {
        padding: '0 !important',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
    },
    toolbar: {
        padding: '12px 20px',
        borderBottom: '1px solid #e2e8f0',
        display: 'flex',
        justifyContent: 'flex-end',
    },
    tableWrapper: {
        flex: 1,
        overflow: 'auto',
        margin: '20px',
        '& table': {
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: '0.85rem',
        },
        '& thead': {
            background: '#778899',
            position: 'sticky',
            top: 0,
            zIndex: 10,
        },
        '& th': {
            padding: '12px 16px',
            textAlign: 'left',
            color: '#fff',
            fontWeight: 600,
            fontSize: '0.85rem',
            borderRight: '1px solid rgba(255,255,255,0.1)',
            letterSpacing: '0.3px',
            position: 'sticky',
            top: 0,
            background: '#778899',
            userSelect: 'none',
            zIndex: 9,
            '&:last-child': {
                borderRight: 'none',
            },
        },
        '& tbody tr': {
            background: '#fff',
            borderBottom: '1px solid #edf2f7',
            transition: 'background-color 0.2s ease',
            '&:nth-of-type(odd)': {
                background: '#f8fafc',
            },
            '&:hover': {
                background: '#f0f7ff',
            },
        },
        '& td': {
            padding: '12px 16px',
            borderRight: '1px solid #edf2f7',
            color: '#334155',
            fontSize: '0.85rem',
            '&:last-child': {
                borderRight: 'none',
            },
        },
        '& .btngridcel': {
            padding: '2px 8px',
            fontSize: '0.75rem',
            textDecoration: 'underline',
            color: '#267db7',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            '&:hover': {
                color: '#1e5a8a',
            },
        },
    },
}));

const AuditTrail = ({
    hideComponent,
    dsarRequestId
}) => {
    const classes = useStyles();
    const [auditTrailData, setAuditTrailData] = useState();
    const context = useContext(AppContext)
    const authToken = context.authToken.get


    useEffect(() => {
        axios.get(`ticket/audittrail/${dsarRequestId}`, {
            headers: {
                Authorization: authToken
            }
        }).then(res => {
            setAuditTrailData(res.data?.map((_displayAuditTrailData,index)=>{
                return {
                    rowId: index + 1,
                    created_date_UTC : getFormatedDate(_displayAuditTrailData.created_date, true),
                    created_date_Local : getFormatedDate(_displayAuditTrailData.created_date),
                    ..._displayAuditTrailData
                }
            }))
        }).catch(err => {
            console.log(err)
        })
     
  // eslint-disable-next-line react-hooks/exhaustive-deps
},[dsarRequestId])

    const downloadAuditLogs = () => {
        let csv = "#,Activity,Details,User,Date Time"
        csv = auditTrailData.reduce((total, {
            rowId,
            activity,
            additional_data,
            user_name,
            created_date_UTC
        }) => total + `\n${rowId},${activity},${additional_data === null ? '' : 
            additional_data.replace(/[\n,]/g, ' ')},${user_name},${created_date_UTC.replace(/[\n,]/g, ' ')}`, csv);
		const link = document.createElement('a');
        const file = new Blob(["\ufeff", csv])
        link.href = URL.createObjectURL(file);
        link.setAttribute('download', `Audit_Trail_${dsarRequestId}.csv`);
		document.body.appendChild(link);
		link.click();
		link.remove()
	}
    const handleDownloadClick =async(payload_type, rowData)=>{

        const res = await axios.get(`download/${rowData.dsar_id}/${rowData.id}/${payload_type}`, {
            headers: {
                Authorization: authToken
            }
        });

        const fileLink = res.data.presignedGet;
        if(fileLink){
            const link = document.createElement('a');
       
        link.href = fileLink;
        link.setAttribute('download', `${rowData.id}_${payload_type}.json`);
		document.body.appendChild(link);
		link.click();
		link.remove()
        }

    }
    
    return (
        <Dialog
            open={true}
            classes={{ paper: classes.dialogPaper }}
            maxWidth={false}
        >
            <DialogTitle className={classes.dialogTitle} disableTypography>
                <span className={classes.titleText}>Audit Trail</span>
                <div className={classes.iconActions}>
                    <button onClick={hideComponent} aria-label="close">
                        <CloseIcon fontSize="small" />
                    </button>
                </div>
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
                {!auditTrailData && <LoadingIndicator />}
                {auditTrailData && (
                    <>
                        <div className={classes.toolbar}>
                            <Button
                                variant="contained"
                                startIcon={<GetAppIcon />}
                                onClick={downloadAuditLogs}
                                sx={standardButtonStyle}
                            >
                                Download
                            </Button>
                        </div>
                        <div className={classes.tableWrapper}>
                            <table>
                                <thead>
                                    <tr>
                                        <th style={{ width: '50px' }}>#</th>
                                        <th style={{ width: '200px' }}>Activity</th>
                                        <th style={{ width: '250px' }}>Details</th>
                                        <th style={{ width: '150px' }}>Logs</th>
                                        <th style={{ width: '100px' }}>User</th>
                                        <th style={{ width: '180px' }}>Date Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {auditTrailData.map((row) => (
                                        <tr key={row.rowId}>
                                            <td>{row.rowId}</td>
                                            <td title={row.activity}>{row.activity}</td>
                                            <td title={row.additional_data || ''}>{row.additional_data || ''}</td>
                                            <td>
                                                {row.download_flag ? (
                                                    <>
                                                        <button className="btngridcel" onClick={() => handleDownloadClick('request', row)}>api-request</button>
                                                        {', '}
                                                        <button className="btngridcel" onClick={() => handleDownloadClick('response', row)}>api-response</button>
                                                    </>
                                                ) : null}
                                            </td>
                                            <td title={row.user_name}>{row.user_name}</td>
                                            <td title={row.created_date_Local}>{row.created_date_UTC}</td>
                                        </tr>
                                    ))}
                                    {auditTrailData.length === 0 && (
                                        <tr>
                                            <td colSpan={6} style={{ textAlign: 'center', padding: '20px', color: '#64748b' }}>
                                                No audit trail data available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
            </DialogContent>
        </Dialog>
    )
}
export default AuditTrail;